// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  margin-bottom: 2em;
  padding: 1.6em;
  border-radius: 2em;
  text-align: center;
  background-color: #282c34;
  color: white;
}

.App-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
}

.App-link {
  color: #61dafb;
}

.App-btn {
  background-color: #61dafb;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  margin: 0 10px;
  cursor: pointer;
}

.App-container {
  text-align: center;
  margin-top: 50px;
}

.App-counter-value {
  display: inline-block;
  width: 120px;
  font-size: 24px;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./packages/react-16-app/src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".App {\n  margin-bottom: 2em;\n  padding: 1.6em;\n  border-radius: 2em;\n  text-align: center;\n  background-color: #282c34;\n  color: white;\n}\n\n.App-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.App-btn {\n  background-color: #61dafb;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  padding: 10px 20px;\n  margin: 0 10px;\n  cursor: pointer;\n}\n\n.App-container {\n  text-align: center;\n  margin-top: 50px;\n}\n\n.App-counter-value {\n  display: inline-block;\n  width: 120px;\n  font-size: 24px;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
